// extracted by mini-css-extract-plugin
export default {"btnHover":"Education_btnHover__TduT3"};